import { headerScripts } from './header.ts';
import { articleListScripts } from './article-list.ts';
import { cardsScripts } from './cards.ts';
import { articleAnchorLinks } from './article-anchor-links.ts';
import { initTrustpilot } from './trustpilot.ts';
import { documentListScripts } from "./document-list.ts";
import { jumpToAnchor } from './jump-to-anchor.ts';
import { initRatingsScale } from './performance-range-slider.ts';
import { embeddedShorthand } from '../../../common/white-label/scripts/embedded-shorthand.ts';

window.addEventListener('load', () => {
    headerScripts();
    articleListScripts();
    articleAnchorLinks();
    cardsScripts();
    initTrustpilot();
    documentListScripts();
    jumpToAnchor();
    embeddedShorthand();
    initRatingsScale();
});